if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
        this.updateBorders();
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
        this.updateBorders();
      });

      this.addEventListener('toggle', () => {
        this.updateBorders();
      });

      this.updateBorders();
    }

    updateBorders() {
      const allDetails = Array.from(this.parentElement.querySelectorAll('footer-details'));
      const closedDetails = allDetails.filter(d => !d.open);

      allDetails.forEach(d => d.classList.remove('last-closed'));

      if (closedDetails.length) {
        const lastClosed = closedDetails[closedDetails.length - 1];
        lastClosed.classList.add('last-closed');
      }
    }
  }

  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
